import { ApiService } from '../model/Api.model';
import { AxiosInstance } from 'axios';
import { IDiligenceReAnalysis } from '../interface/ticket/IDiligenceReAnalysis';
import { IQuestionnaireDifferences } from '../interface/ticket/IQuestionnaireDifferences';


enum DiligenceReAnalyisEnum {
  BASE = "/",
  QUESTIONNAIRE_DIFFERENCES = "/compare-trade-questionnaire"
}

export default class DiligenceReAnalyisService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/diligence-analysis");
  }
  public getAll = async (): Promise<IDiligenceReAnalysis[]> => await this.GET(DiligenceReAnalyisEnum.BASE);

  public getQuestionnaireDifferences = async (reAnalysisId: string | number): Promise<IQuestionnaireDifferences[]> => {
    const data = await this.GET(`${DiligenceReAnalyisEnum.QUESTIONNAIRE_DIFFERENCES}/${reAnalysisId}`);
    return data;
  };

}
